/*
 * MEPP - A web application to guide patients and clinicians in the process of
 * facial palsy rehabilitation, with the help of the mirror effect and principles
 * of motor learning
 * Copyright (C) 2021 MEPP <info@mirroreffectplus.org>
 *
 * This file is part of MEPP.
 *
 * MEPP is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * MEPP is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with MEPP.  If not, see <http://www.gnu.org/licenses/>.
 */
import React from 'react';

import SvgIcon from '@mui/material/SvgIcon';

export const SoundIcon = () => {
  return (
    <SvgIcon viewBox="0 0 24 24">
      <path d="M16.8828 11.5C16.8828 9.73571 15.8897 8.21571 14.4138 7.42857V15.5714C15.8759 14.7843 16.8828 13.2643 16.8828 11.5ZM2 8.78571V14.2143H6.13793L11.6552 19.6429V3.35714L6.13793 8.78571H2ZM14.4138 2V4.03571C17.6138 5.04 19.931 8.01214 19.931 11.5C19.931 14.9879 17.6138 17.96 14.4138 18.9643V21C18.7586 19.9414 22 16.1143 22 11.5C22 6.88571 18.7586 3.05857 14.4138 2Z" />
    </SvgIcon>
  );
};
